// Закрытые роуты — требуют авторизации. Гость, попавший сюда, редиректится
// на "/" с одновременным открытием модалки входа (returnTo = исходный путь),
// как в IEC Hero. Матчинг — по точному пути или префиксу со слешем
// (`/materials` ⇒ `/materials`, `/materials/...`; НЕ `/materialsX`).
//
// Публичные (НЕ в списке): "/", /about, /faq, /method (разбор метода со
// ссылками на исследования), /pricing, /download, /catalog (витрина курсов,
// включая /catalog/{slug}), /legal/$kind, /shared/$token, /offline.
// Служебные auth-flow (/auth/*, /legal/accept, /onboarding/*, /impersonate)
// обрабатываются отдельно в AuthFlowGate и здесь НЕ перечисляются — иначе
// двойной редирект/петля.
//
// ВАЖНО про `/catalog`: он лежит ВНЕ `/courses` именно потому, что весь этот
// префикс закрыт. Публичный раздел внутри закрытого держался бы на списке
// точечных исключений `PUBLIC_EXCEPTION_PREFIXES` (см. ниже) — а это мина:
// каждый новый вложенный роут по умолчанию оказывался бы публичным или
// закрытым не туда. Не переносить каталог обратно под `/courses` и не
// добавлять `/catalog` в список ниже.

const PROTECTED_PREFIXES = [
	// Материалы и контент
	"/library",
	"/materials",
	"/notes",
	"/glossary",
	"/search",
	// Учёба
	"/courses",
	"/flashcards",
	"/tests",
	"/weak-spots",
	"/progress",
	"/study-plan",
	"/calendar",
	// AI-инструменты
	"/tutor",
	"/tools",
	"/recordings",
	"/audio-recaps",
	// Личное
	"/settings",
	"/notifications",
	"/billing",
] as const;

/**
 * Публичные страницы ВНУТРИ закрытых префиксов.
 *
 * Проверяются ПЕРВЫМИ. Реальный инцидент 2026-08-09: `/audio-recaps/share/<token>`
 * — публичная страница по ссылке, но она лежит под закрытым `/audio-recaps`,
 * и гейт открывал гостю модалку входа. То есть кнопка «Поделиться» выдавала
 * ссылку, по которой никто, кроме автора, ничего не мог послушать — фича была
 * мёртвой с момента появления.
 *
 * Правило на будущее: любая страница «по ссылке без аккаунта» обязана быть
 * либо вне закрытых префиксов, либо здесь.
 */
const PUBLIC_EXCEPTION_PREFIXES = ["/audio-recaps/share/"] as const;

export function isPublicExceptionPath(pathname: string): boolean {
	return PUBLIC_EXCEPTION_PREFIXES.some((p) => pathname.startsWith(p));
}

export function isProtectedPath(pathname: string): boolean {
	if (isPublicExceptionPath(pathname)) return false;
	return PROTECTED_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
